export default {
	rolepermission: {
		name: '@:entity.role.name',
	},
}
